import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { GameLogic } from '../../Logic/GameLogic';
import { AnimationContents } from '../../../AnimationContents';
import { MiniGameModel, MiniGameTypeEnum } from '../../Models/MiniGameModel';
import { Container, Sprite } from 'pixi.js';

export class UIQuestPointerController extends AnimationBaseController {
    $model: MiniGameModel;

    private screenWidth: number = 0;
    private screenHeight: number = 0;

    public constructor(@Inject private _options,
                       @Inject private _gameLogic: GameLogic) {
        super('UIPointerMiniGameController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.GAME_SCREEN_JSON,
            libraryName: 'quest_pointers',
            modelWatch: {
                screenPos: (value: [number, number]) => {
                    this.updatePosition();
                },
            },
        };
    }

    protected onInitialize(): void {
        this.gotoAndStop(this.$model.type);
        this.updatePosition();
    }

    protected onResize(width: number, height: number, scale: number) {
        this.screenWidth = width;
        this.screenHeight = height;
    }

    protected updatePosition(): void {
        let global = new PIXI.Point(this.$model.screenPos[0], this.$model.screenPos[1]);
        let { x, y } = this.display.parent.toLocal(global, this.renderer.stage);

        const margin = 0;

        let leftTop = this.display.parent.toLocal(new PIXI.Point(margin, margin), this.renderer.stage);
        let rightTop = this.display.parent.toLocal(new PIXI.Point(this.screenWidth - margin, margin), this.renderer.stage);
        let leftBottom = this.display.parent.toLocal(new PIXI.Point(margin, this.screenHeight - margin), this.renderer.stage);

        let isOutOfScreen = false;

        if (x - this.display.width / 2 < leftBottom.x) {
            x = leftBottom.x + this.display.width / 2;
            isOutOfScreen = true;
        }
        if (x + this.display.width / 2 > rightTop.x) {
            x = rightTop.x - this.display.width / 2;
            isOutOfScreen = true;
        }
        if (y - this.display.height / 2 < leftTop.y) {
            y = leftTop.y + this.display.height / 2;
            isOutOfScreen = true;
        }
        if (y + this.display.height / 2 > leftBottom.y) {
            y = leftBottom.y - this.display.height / 2;
            isOutOfScreen = true;
        }

        const unitPosition = this._gameLogic.getUnitScreenPosition();
        const unitPositionLocal = this.display.parent.toLocal(new PIXI.Point(unitPosition[0], unitPosition[1]), this.renderer.stage);

        const distX = x - unitPositionLocal.x;
        const distY = y - unitPositionLocal.y;

        const dist = isOutOfScreen ? 0 : -100;

        const angle = Math.atan2(distY, distX);
        const rotation = angle + 90 * Math.PI / 180;
        const arrow = this.getDisplayObjectByQuery('quest_arrow')[0];

        const strokeContainer = this.getDisplayObjectByQuery('stroke')[0] as Container;
        const strokeSprite = strokeContainer.getChildAt(0) as Sprite;

        this.x = x + Math.cos(angle) * dist;
        this.y = y + Math.sin(angle) * dist;


        arrow.visible = !this.$model.selected;
        arrow.rotation = rotation;

        strokeContainer.visible = this.$model.selected;
        strokeSprite.tint = 0xfff000;

        switch (this.$model.type) {
            case MiniGameTypeEnum.laser:
            case MiniGameTypeEnum.fuel:
                this.visible = this._gameLogic.foundTaskScreen() && !this._gameLogic.isMiniGameComplete(MiniGameTypeEnum.engine)
                break;

            case MiniGameTypeEnum.ropes:
                this.visible = this._gameLogic.isMiniGameComplete(MiniGameTypeEnum.engine);
                break;

            default:
                this.visible = !this._gameLogic.isMiniGameComplete(MiniGameTypeEnum.engine);
        }
    }
}

